import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WarrantyOptionConfigModel } from '../../components/WarrantyOptions/component';
import { Step } from '../../configurator/models/Step';

type TPayload = {
    steps: Step[];
};

export type InsuranceState ={
    loading:boolean,
    insuranceEnabled:boolean,
    warranty?:WarrantyOptionConfigModel
}

const initialState:InsuranceState = {
    loading:false,
    insuranceEnabled:false
};

const insuranceSlice = createSlice({
    name: 'insurance',
    initialState: initialState,
    reducers: {
        setInsuranceEnabled: (state, { payload }: PayloadAction<boolean>) => {
            state.insuranceEnabled=payload;
        },
        setInsuranceLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.loading=payload;
        },
        setWarranty : (state, { payload }: PayloadAction<WarrantyOptionConfigModel>) => {
            state.warranty=payload;
        },
    },
  });

export const insuranceReducer = insuranceSlice.reducer;
export const insuranceActions = insuranceSlice.actions;